export class PageError extends Error {}
